import React, { useRef } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  OutlinedInput,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import ButtonDefault from "../shared/button/button";
import AlertMessage from "../shared/alert/alert";
import { useStyles, ProfileLogic, validateCellphone } from "./profile.module";

const CellphoneAccordion = () => {
  const classes = useStyles();
  const cellphoneRef = useRef();

  const {
    current,
    changeState,
    cellphone,
    setCellphone,
    handleCellphoneSubmit,
    successCellphone,
    errorCellphone,
    mfaEnabled,
    translator,
    handleMFAToggle,
    successMFA,
    errorMFA,
    cellphoneSaved, 
  } = ProfileLogic(validateCellphone);

  const handleChange = (e) => {
    const value = e.target.value;
    const cleaned = value.replace(/[^\d+]/g, "");
    if (cleaned.startsWith("+") && cleaned.slice(1).length <= 15) {
      setCellphone(cleaned);
    } else if (!cleaned.startsWith("+") && cleaned.length <= 15) {
      setCellphone(cleaned);
    }
  };

  return (
    <Accordion onChange={changeState(2)}>
      <AccordionSummary
        className={classes.root}
        expandIcon={
          current === 2 ? (
            <RemoveCircleOutlineIcon
              className={classes.removeCircleOutlineIcon}
            />
          ) : (
            <AddCircleOutlineIcon className={classes.addCircleOutlineIcon} />
          )
        }
        aria-controls="panel3a-content"
        id="panel3a-header"
      >
        <Typography variant="h5" className={classes.questionsWhite}>
          {translator("cellphone_title")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <label className={classes.labels}>
                {translator("cellphone_label")}
              </label>
              <OutlinedInput
                className={classes.outlinedInputProfile}
                placeholder="+52 2221025654"
                value={cellphone}
                inputRef={cellphoneRef}
                onChange={handleChange}
                inputProps={{
                  pattern: "^[+][1-9][0-9]{1,14}$",
                  maxLength: 16,
                  inputMode: "tel",
                }}
              />
            </FormControl>
          </Grid>

          {successCellphone && (
            <Grid item xs={12} style={{ marginTop: "-8px" }}>
              <AlertMessage
                text={translator("cellphone_message")}
                type="success"
              />
            </Grid>
          )}

          {errorCellphone && (
            <Grid item xs={12} style={{ marginTop: "-8px" }}>
              <AlertMessage text={errorCellphone} type="error" />
            </Grid>
          )}

          <Grid item xs={12} className={classes.checkboxContainer}>
            {mfaEnabled !== null && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={mfaEnabled}
                    onChange={(e) => handleMFAToggle(e.target.checked)}
                    color="default"
                    inputProps={{ "aria-label": "Activar MFA" }}
                    disabled={!cellphoneSaved} 
                  />
                }
                label={translator("cellphone_mfa")}
              />
            )}
          </Grid>

          {successMFA && (
            <Grid item xs={12} style={{ marginTop: "-8px" }}>
              <AlertMessage
                text={translator("cellphone_enabled_mfa")}
                type="success"
              />
            </Grid>
          )}

          {errorMFA && (
            <Grid item xs={12} style={{ marginTop: "-8px" }}>
              <AlertMessage text={errorMFA} type="error" />
            </Grid>
          )}

          <Grid item xs={12} className={classes.buttonContainer}>
            <ButtonDefault
              type="blue"
              text={translator("cellphone_button")}
              changeView={() =>
                handleCellphoneSubmit(cellphoneRef.current.value)
              }
              align="center"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default CellphoneAccordion;
